<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="templateSelected"
    :clearable="!unclearable"
    :items="templates"
    :loading="templatesLoading"
    :search-input.sync="templatesSearch"
    item-text="template_name"
    item-value="id"
    :label="noLabel ? '' : $t('TakeTemplates.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import TakeTemplates from "@/api/take_templates";

export default {
  name: "SearcherTakeTemplate",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
  },

  data: () => ({
    templates: [],
    templatesLoading: false,
    templatesSearch: "",
    templateSelected: null,
  }),

  mounted() {
    this.getTemplatesFromAPI();
  },

  methods: {
    getTemplatesFromAPI() {
      this.templatesLoading = true;
      TakeTemplates.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templates = response.data.take_templates;
            }
            this.templatesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.templatesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.templateSelected = this.value;
      },
    },
    templateSelected: {
      handler() {
        this.$emit("input", this.templateSelected);
      },
    },
  },
};
</script>
